// extracted by mini-css-extract-plugin
export default {"contentContainer":"weY6R2Pn11dLSF3zKy7T","paymentGroup":"P2Wj4EsJFZCqpp2cS2Jo","cosignerSubtext":"SshIoL1C5JaH0hlwYBtn","editButton":"CB5sqG3eqeYx249ph6z5"};